<template>
  <path
    d="M4.11 2.54024C3.72 2.15024 3.09 2.15024 2.7 2.54024C2.31 2.93024 2.31 3.56024 2.7 3.95024L4.74 6.00024H4C2.89 6.00024 2.01 6.89024 2.01 8.00024L2 19.0002C2 20.1102 2.89 21.0002 4 21.0002H19.74L21.03 22.2902C21.42 22.6802 22.05 22.6802 22.44 22.2902C22.83 21.9002 22.83 21.2702 22.44 20.8802L4.11 2.54024ZM10 4.00024H14V6.00024H10.4L22 17.6002V8.00024C22 6.89024 21.11 6.00024 20 6.00024H16V4.00024C16 2.89024 15.11 2.00024 14 2.00024H10C9.01 2.00024 8.2 2.70024 8.04 3.64024L10 5.60024V4.00024Z"
  />
</template>
